import { FaSpinner as Loader2Icon } from "react-icons/fa"

import { cn } from "@/core/helpers/misc/GeneralUtils"

function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn("shadcn-spinner size-4 animate-spin", className)}
      {...props}
    />
  )
}

export { Spinner }
